import "../css/invoice.css";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import GeneralDetails from "./GeneralDetails";
import InvoiceDetails from "./InvoiceDetails";
import GrandTotal from "./GrandTotal";
import { useEffect, useMemo, useState } from "react";
import Payment from "./Payment";
import { IoClose } from "react-icons/io5";
import { useItemsFilterNew } from "../../_helper/actions/app/items";
import { useAtom } from "jotai";
import {
  clinicAtom,
  doctorSettingAtom,
} from "../../_helper/constant/constant-atom";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { INITIAL_STATE } from "../_constant";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import moment from "moment";
import CuSpinner from "../../common_component/component/CuSpinner";
import { FcPaid } from "react-icons/fc";
import { toast } from "react-toastify";
// import { secureAxios } from "../../_helper/constant/auth";
// import InvoicePrint from "../../credit_invoice/components/InvoicePrint";
// import ReactDOMServer from "react-dom/server";
// import { getImageURL } from "../../_helper/utils/image";

const Invoice = ({ event, onClose, setIsPrint, sm, doctor_id }) => {
  const [invoicePayload, setInvoicePayload] = useState(INITIAL_STATE);
  const [invoiceLines, setInvoiceLines] = useState([]);
  const [getInvoiceID, setGetInvoiceId] = useState("");
  const [doctorSettings] = useAtom(doctorSettingAtom);
  const [sendNotification, setSendNotification] = useState(true);
  const [isPDFLoading, setIsPDFLoading] = useState(false);
  const [payments, setPayments] = useState([
    {
      status: "paid",
      transaction_date: moment().format("YYYY-MM-DD"),
      payment_mode: 1,
      transaction_details: "",
      received_payment: 0,
    },
  ]);
  const [isFull, setIsFull] = useState(true);
  const [fullPaymentForm, setFullPaymentForm] = useState({
    status: "paid",
    transaction_date: moment().format("YYYY-MM-DD"),
    payment_mode: 1,
    transaction_details: "",
    received_payment: 0,
  });
  const [sections, setSections] = useState([
    {
      name: "Service Details",
      isOpen: true,
    },
    { name: "Grand Total", isOpen: false },
    {
      name: "Payment",
      isOpen: true,
    },
  ]);
  const [clinic] = useAtom(clinicAtom);

  const getInvoiceNo = (response) => {
    return response.invoice_number;
  };

  const getInvoiceData = (response) => {
    return response.data;
  };

  const { data: invoiceNo } = useItemsFilterNew(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    `?action=getNumberSequenceByname&clinic_id=${clinic?.id}&backend=True&transaction_type=OPD INVOICE&bill_type=OPD`,
    clinic?.id && !event?.billing_status?.id ? true : false,
    getInvoiceNo
  );

  const sendnotificationMutation = useCreateItem(ApiEndPoint.PAYMENTS_BILLING);

  const viewInvoiceQuery = `?action=getBillingCreditInvoice&frontend=True&clinic_id=${clinic?.id}&id=${event?.billing_status?.id ? event?.billing_status?.id : getInvoiceID}`;

  //(viewInvoiceQuery);
  const { data: editData } = useItemsFilterNew(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    viewInvoiceQuery,
    clinic?.id && (event?.billing_status?.id || getInvoiceID) ? true : false,
    getInvoiceData
  );

  //("Edited Data", editData);

  //("Edit Data Runned", editData);

  const handleNotification = () => {
    const payload = {
      action: "postSendBill",
      patient_id: event?.user_details?.id,
      clinic_id: event?.clinic_id,
      doctor_id: doctor_id,
      prescription_url: "login/?callback=/p/appointment?slot_status=completed",
    };

    console.log("Sending Notification Payload:", payload);

    sendnotificationMutation.mutate(payload, {
      onSuccess: () => {
        toast.success(
          "The recipient has been notified via WhatsApp successfully."
        );
      },
      onError: (error) => {
        console.error("Error sending notification:", error);
        toast.error("Failed to send the notification. Please try again.");
      },
    });
  };

  const toggleSection = (index) => {
    setSections(
      sections.map((section, i) =>
        i === index ? { ...section, isOpen: !section.isOpen } : section
      )
    );
  };

  const getInvoiceTotal = () => {
    //("Invoice Lines", invoiceLines);
    const grandTotal = invoiceLines?.reduce(
      (acc, line) =>
        acc +
        Number(
          line.description === "MEDICINE CHARGES" ? line?.total : line?.price
        ),
      0
    );
    return grandTotal;
  };

  const totalWithoutDisc = useMemo(getInvoiceTotal, [invoiceLines]);

  const getInvoiceLines = (lines = []) => {
    const modifiedLines = lines?.map((line) => {
      return { ...line, line_service: line?.line_service?.id };
    });
    return modifiedLines || [];
  };

  const getInvoicePayments = (payments = []) => {
    const modifiedLines =
      payments?.map((payment) => {
        return {
          ...payment,
          transaction_date: moment(payment?.transaction_date).format(
            "YYYY-MM-DD"
          ),
          payment_mode: payment?.payment_mode?.id,
        };
      }) || [];

    // modifiedLines.push({
    //   status: "paid",
    //   transaction_date: moment().format("YYYY-MM-DD"),
    //   payment_mode: 1,
    //   transaction_details: "",
    //   received_payment: 0,
    // });
    return modifiedLines;
  };

  useEffect(() => {
    const grandTotal = getInvoiceTotal();
    setInvoicePayload((prev) => ({ ...prev, invoice_total: grandTotal }));
  }, [invoiceLines]);

  // useEffect(() => {
  //   if (payments?.length === 1) {
  //     setPayments((prev) => {
  //       const temp = [...prev];
  //       temp[0] = {
  //         ...temp[0],
  //         received_payment: invoicePayload?.invoice_total,
  //       };
  //       return temp;
  //     });
  //   }
  // }, [invoicePayload?.invoice_total]);

  useEffect(() => {
    if (event && invoiceNo) {
      setInvoicePayload({
        invoice_no: invoiceNo,
        invoice_total: 0,
        slot_id: event?.id,
        opd: {
          id: event?.opd?.id,
          opd_number: event?.opd?.opd_number,
          date: moment(event?.opd_date).format("DD MMMM YYYY"),
        },
        invoice_date: moment().toDate(),
        status: "draft",
        admission_details: {
          admission_date: "",
          admission_time: "",
          discharge_date: "",
          discharge_time: "",
          IPD_No: "",
          ipd_id: null,
          injury_no: "",
        },
        discount: 0,
        discount_type: "percentage",
        patient_details: {
          id: event?.user_details?.id,
          full_name: event?.user_details?.full_name,
          phone: event?.user_details?.phone,
        },
      });
    }
  }, [event, invoiceNo]);

  useEffect(() => {
    if (editData) {
      setInvoicePayload({
        id: editData?.id,
        invoice_no: editData?.invoice_no,
        invoice_total: editData?.invoice_total,
        slot_id: editData?.slot_id,
        opd: {
          id: editData?.consultation_data?.id,
          opd_number: editData?.consultation_data?.opd_number,
          date: moment(editData?.consultation_data?.opd_date).format(
            "DD MMMM YYYY"
          ),
        },
        invoice_date: editData?.invoice_date,
        status: editData?.status,
        admission_details: editData?.admission_details,
        discount: editData?.discount,
        discount_type: editData?.discount_type,
        patient_details: editData?.patient_details,
      });
      setPayments(getInvoicePayments(editData?.billing_credit_payments));
      setInvoiceLines(getInvoiceLines(editData?.invoice_lines));
    }
  }, [editData]);

  const postInvoiceMutation = useCreateItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    ApiEndPoint.QM_SC_SLOTS
  );
  const updateInvoiceMutation = useSecureUpdateItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    ApiEndPoint.QM_SC_SLOTS
  );

  const afterSuccessfulSubmit = (data, status) => {
    if (status === "published") {
      // handleDirectSubmit(data);
      onClose();
    } else {
      onClose();
    }
  };

  const handleSubmitInvoice = (status, type = "all") => {
    if (type === "grandTotal") {
      const action = invoicePayload?.id
        ? "patchBillingCreditInvoice"
        : "postBillingCreditInvoice";
      // Assuming you want to update these fields for the existing invoicePayload
      let updatedPayload = {
        action,
        clinic_id: clinic?.id,
        id: invoicePayload?.id,
        invoice_total: invoicePayload?.invoice_total,
        discount: invoicePayload?.discount,
        discount_type: invoicePayload?.discount_type,
      };

      // Trigger the update for the invoice (you might want to use the same mutation logic here)
      updateInvoiceMutation.mutate(
        { data: updatedPayload },
        {
          onSuccess: () => {
            if (type == "grandTotal") {
              toast.success("Discount Applied!");
            } else {
              onClose();
            }
          },
          onError: (err) => {
            toast.error(
              err.response.data.error_msg || err.response.data.message
            );
          },
        }
      );
    } else {
      const receivingAmt = payments?.reduce(
        (acc, payment) => acc + Number(payment?.received_payment),
        0
      );

      if (Number(receivingAmt) > Number(invoicePayload?.invoice_total)) {
        toast.error("You cannot pay more than the invoice");
        return;
      }

      if (invoiceLines?.length > 0) {
        // const pdf_payload = await generatePDF(
        //   status === "published",
        //   invoicePayload?.id
        // );

        const action = invoicePayload?.id
          ? "patchBillingCreditInvoice"
          : "postBillingCreditInvoice";

        const billing_credit_payments =
          payments?.filter(
            (ele) => ele?.received_payment > 0 && ele?.payment_mode
          ) || [];

        if (
          isFull &&
          fullPaymentForm?.received_payment > 0 &&
          fullPaymentForm?.transaction_date?.length > 0
        ) {
          billing_credit_payments.push(fullPaymentForm);
        }

        let payload = {
          action,
          clinic_id: clinic?.id,
          id: invoicePayload?.id,
          invoice_no: invoicePayload?.invoice_no,
          invoice_total: invoicePayload?.invoice_total,
          slot_id: invoicePayload?.slot_id,
          bill_type: "OPD",
          invoice_date: invoicePayload?.invoice_date,
          invoice_lines: invoiceLines,
          billing_credit_payments,
          status: status,
          admission_details: {
            admission_date: "",
            admission_time: "",
            discharge_date: "",
            discharge_time: "",
            IPD_No: "",
            ipd_id: null,
            injury_no: "",
          },
          discount: invoicePayload?.discount,
          discount_type: invoicePayload?.discount_type,
          patient_details: invoicePayload?.patient_details?.id,
          feature_name: "invoice",
          // pdf_payload,
        };

        if (invoicePayload?.id) {
          updateInvoiceMutation.mutate(
            { data: payload },
            {
              onSuccess: () => {
                onClose();
              },
              onError: (err) => {
                toast.error(
                  err.response.data.error_msg || err.response.data.message
                );
              },
            }
          );
        } else {
          postInvoiceMutation.mutate(payload, {
            onSuccess: (data) => afterSuccessfulSubmit(data, status),
            onError: (err) => {
              toast.error(
                err.response.data.error_msg || err.response.data.message
              );
            },
          });
        }
      } else {
        toast.error("Invoice cannot be created without a single service");
      }
    }
  };

  const handlePrint = () => {
    // if (!sm) {
    setIsPrint({ data: invoicePayload, flag: true });
    onClose();
    // }
  };
  //("Invoice Lines Runned", invoiceLines);
  //("Invoice Payload", invoicePayload);

  return (
    <div className="px-10 py-9">
      <div className="flex justify-between items-center pb-6">
        <span className="text-[#4B4B4B] text-[16px] leading-[18.4px] font-bold">
          Invoice
        </span>
        <span>
          <IoClose onClick={onClose} size={20} className="cursor-pointer" />
        </span>
      </div>
      <div className="w-full">
        <GeneralDetails
          invoiceNo={invoicePayload?.invoice_no}
          mobileNo={invoicePayload?.patient_details?.phone}
          fullName={invoicePayload?.patient_details?.full_name}
          opdNo={invoicePayload?.opd?.opd_number}
          appointmentNo={event?.id}
        />
        {sections.map((section, index) => (
          <div key={index} className="mt-3">
            <div
              className="w-full h-10 flex justify-between items-center text-[#4B4B4B] text-[16px] leading-[18.4px]"
              onClick={() => toggleSection(index)}
            >
              {section.name !== "Grand Total" && <span>{section.name}</span>}
              {section.name === "Grand Total" && (
                <span>
                  Grand Total : ₹{" "}
                  {invoicePayload?.invoice_total
                    ? invoicePayload?.invoice_total
                    : 0}
                </span>
              )}
              {section.isOpen ? (
                <FaAngleUp size={20} className="cursor-pointer" />
              ) : (
                <FaAngleDown size={20} className="cursor-pointer" />
              )}
            </div>
            {section.isOpen && section.name === "Service Details" && (
              <InvoiceDetails
                invoiceLines={invoiceLines}
                setInvoicePayload={setInvoicePayload}
                setInvoiceLines={setInvoiceLines}
                invoiceStatus={invoicePayload?.status}
                invoiceId={invoicePayload?.id}
                invoicePayload={invoicePayload}
                setGetInvoiceId={setGetInvoiceId}
              />
            )}
            {section.isOpen && section.name === "Grand Total" && (
              <GrandTotal
                total={totalWithoutDisc}
                invoicePayload={invoicePayload}
                setInvoicePayload={setInvoicePayload}
                setPayments={setPayments}
                payments={payments}
                onSaveInvoice={handleSubmitInvoice}
                isLoading={
                  updateInvoiceMutation.isLoading ||
                  postInvoiceMutation.isLoading
                }
              />
            )}
            {section.isOpen && section.name === "Payment" && (
              <Payment
                payments={payments}
                fullPaymentForm={fullPaymentForm}
                setFullPaymentForm={setFullPaymentForm}
                setPayments={setPayments}
                invoicePayload={invoicePayload}
                isFull={isFull}
                setIsFull={setIsFull}
              />
            )}
          </div>
        ))}
      </div>
      <div className="mt-3">
        {(event?.billing_status?.billing_status !== "paid" ||
          invoicePayload?.status === "draft") && (
          <div className="flex items-center gap-3">
            {invoicePayload?.status !== "published" && (
              <button
                className="cu-btn-gray"
                onClick={() => handleSubmitInvoice("draft")}
              >
                {postInvoiceMutation.isLoading ||
                updateInvoiceMutation.isLoading ? (
                  <CuSpinner />
                ) : (
                  "Save"
                )}
              </button>
            )}
            <button
              className="cu-btn-green"
              onClick={() => handleSubmitInvoice("published")}
            >
              {postInvoiceMutation.isLoading ||
              updateInvoiceMutation.isLoading ||
              isPDFLoading ? (
                <CuSpinner />
              ) : (
                "Paid"
              )}
            </button>
          </div>
        )}
        {invoicePayload?.status === "published" && (
          <>
            <div className="flex items-center gap-3">
              <input
                type="checkbox"
                id="sendNotification"
                checked={sendNotification}
                onChange={() => setSendNotification(!sendNotification)}
                className="w-5 h-5 text-green-600 border-gray-300 rounded focus:ring-green-500"
              />
              <label
                htmlFor="sendNotification"
                className="text-gray-700 text-sm md:text-base"
              >
                Send notification: "Your invoice is ready"
              </label>
            </div>
            <div className="flex gap-6 m-3">
              <button className="cu-btn-green" onClick={handlePrint}>
                Print Recipt
              </button>
              {sendNotification && (
                <button
                  className="cu-btn-green"
                  onClick={handleNotification}
                  disabled={sendnotificationMutation.isLoading}
                >
                  {sendnotificationMutation.isLoading ? "Sending..." : "Send"}
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Invoice;
